import React, {Component} from "react";
import Select from "antd/lib/select";

class CustomerMaritalStatus extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);

        this.initState = {
            customerMaritalStatus: null,
        }
        this.state = {...this.initState}
    }

    onChange = (value: any, option: any) => {
        this.setState({
            customerMaritalStatus: value,
        });
        this.props.onCustomerMaritalStatusChangeProps(option);
    }

    render() {
        return (
            <Select
                placeholder="Status Perkawinan"
                showSearch
                style={{width: "100%"}}
                optionFilterProp="children"
                onChange={this.onChange}
                filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                value={this.props.value ?? this.state.customerMaritalStatus}
            >
                <Select.Option value="single">belum kawin</Select.Option>
                <Select.Option value="married">kawin</Select.Option>
                <Select.Option value="divorced">cerai hidup</Select.Option>
                <Select.Option value="widow">cerai mati</Select.Option>
            </Select>
        );
    }
}

export default CustomerMaritalStatus;
